import React from 'react';
import { FormContext } from './FormContext';
import { InputType } from './InputType';
import RowByType from './Rows/RowByType';
import { RowType } from './RowType';

export const getRowByType = (
	rowOptions,
	formValuesById,
	setFormValuesById,
	formId,
	accountInfoForm = null,
) => {
	const { rowTypeData } = rowOptions;
	if (
		typeof rowTypeData.doShowRow === 'function' &&
		!rowTypeData.doShowRow(formValuesById)
	) {
		return null;
	}

	const contextData = {
		rowOptions,
		formValuesById,
		setFormValuesById,
		formId,
		accountInfoForm,
	};

	return (
		<FormContext.Provider value={contextData}>
			<RowByType />
		</FormContext.Provider>
	);
};

export const getLabelAndInputRow = (
	label,
	inputId,
	isRequired = false,
	inputType = InputType.TextInput,
) => {
	return {
		rowType: RowType.LabelAndInput,
		rowTypeData: {
			label,
			inputId,
			inputType,
			isRequired,
		},
	};
};

export const getLabelAndSelectInputRow = (
	label,
	inputId,
	selectOptions,
	isRequired = false,
) => {
	return {
		rowType: RowType.LabelAndInput,
		rowTypeData: {
			label,
			inputId,
			inputType: InputType.Select,
			selectOptions,
			isRequired,
		},
	};
};
